import { render, staticRenderFns } from "./MembershipBenefitTable.vue?vue&type=template&id=378036cc&scoped=true&"
import script from "./MembershipBenefitTable.vue?vue&type=script&lang=js&"
export * from "./MembershipBenefitTable.vue?vue&type=script&lang=js&"
import style0 from "./MembershipBenefitTable.vue?vue&type=style&index=0&id=378036cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378036cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VSimpleTable,VSpacer,VSystemBar})
